import React from "react";
import { useSpring, animated } from "react-spring";
import Prompts from "./prompts";

//
// Footer Area: Contains
// - optional question in a bubble
// - optional radio buttons to answer the question
// - a Next button that appears when the question is answered, or
//   automatically if there is no question in the footer area
//
const Footer = props => {
  const { item, onChoice, onNext, nextIndex } = props;
  const { choices = [], question, nid, last } = item;
  const enabled = nextIndex !== 0;
  const slide = useSpring({
    //from: { opacity: 0, transform: "translate3d(100%,0,0)" },
    //to: { opacity: 0, transform: "translate3d(0,0,0)" }
    from: { opacity: 0, marginLeft: -100 },
    to: { opacity: 1, marginLeft: 0 }
  });
  const colOne = !question
    ? "small-12 large-4 column mobile-empty"
    : "large-5 small-12 large-offset-1 column";
  const lastQuestion = last === "1";
  return (
    <div className="footer-wrapper">
      <div className="row footer-area">
        <div className={colOne}>
          {!question && <p>&nbsp;</p>}
          {question && (
            <div className="footerQuestionBox">
              <div className="footerQuestion">{question}</div>
            </div>
          )}
        </div>

        {// don't add prompts if it's a form or if there are no prompts
        item.type !== "form" && choices.length > 0 && (
          <div className="large-4 small-12 column prompt">
            <Prompts choices={choices} onChoice={onChoice} qid={nid} />
          </div>
        )}

        <div className="large-2 small-12 column arrow">
          {enabled && !lastQuestion && (
            <animated.button
              style={slide}
              className="blue-arrow"
              onClick={onNext}
              disabled={!enabled}
            >
              Next
            </animated.button>
          )}
          {lastQuestion && (
            /*           <div className="blue-arrow last-button">
            <a href="/">ReStart</a>
          </div> */
            <animated.button
              style={slide}
              className="blue-arrow"
              onClick={onNext}
            >
              Start
            </animated.button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
